<template>
  <div id="app" >
    <FlingController/>
  </div>
</template>

<script>
import FlingController from './components/FlingController.vue';

require('./styles/main.scss');

export default {
  components: {
    FlingController
  }
};
</script>

<style lang='scss' scoped >

#app {
  max-width: $max-width;
  max-height: $max-height;
  width: $max-width;
  height: $max-height;
  top: 0;
  left: 0;
  position: absolute;

  font-family: $text-font-stack;
  font-weight: 800;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  overflow: hidden;
  user-select: none;
}

</style>